import { useFullScreen } from "hooks/useFullScreen";
import { observer } from "mobx-react";
import { type FC, useEffect } from "react";
import { useFullScreenHandle } from "react-full-screen";
import { Outlet } from "react-router-dom";

import {
  StyledFullScreen,
  StyledFullScreenImmersiveReaderContainer,
} from "./subpages/TestOverviewPage/TestOverviewPage.styled";

export const TestPage: FC = observer(() => {
  const fsHandle = useFullScreenHandle();
  const { setFullScreen } = useFullScreen();

  useEffect(() => {
    setFullScreen(fsHandle);
  }, [fsHandle]);

  return (
    <StyledFullScreen handle={fsHandle}>
      <StyledFullScreenImmersiveReaderContainer id="irFullScreenContainer" />
      <Outlet />
    </StyledFullScreen>
  );
});
